import Actions from '../../odata/actions';

const actions = new Actions('customerLocation', 'customerLocations');

export default actions;
